import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const ImageSmallIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue434'}</MuiIcon>
    );
}
